import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5b5cd17a"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b5cd17a')) {
      api.createRecord('5b5cd17a', component.options)
    } else {
      api.reload('5b5cd17a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5b5cd17a", function () {
      api.rerender('5b5cd17a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/design/components/InputNumber/index.vue"
export default component.exports